export const CLIENT_ID = 'productinsights';

export const SCOPE = [
    'offline_access',
    'openid',
    'profile',
    'email',
    'roles',
    'approles',
    'api.products',
    'api.partners.crosstenant',
    'api.productinstances.crosstenant',
    'api.users.crosstenant',
    'api.billing.crosstenant',
    'api.centralservices.crosstenant',
    'api.sts.admin.crosstenant',
    'api.remote.login.crosstenant',
    'api.users',
    'api.provisioning.crosstenant',
    'api.connectedapps.crosstenant'
];

/**
 * Ensure all requests, including libraries such as oidc-client-js, add withCredentials to its XMLHttpRequests.
 * This allows the cookie auth to be initialized and then used on subsequent calls.
 * TODO: Retrigger signin on 401 response from APIs (maybe the cookie expired or was removed)
 */
export function addCookieAuthToRequests(apiUrl) {
    (function (open) {
        XMLHttpRequest.prototype.open = function (method, url, async = true) {
            this.requestUrl = url;
            this.requestMethod = method;
            return open.call(this, method, url, async);
        };
    })(XMLHttpRequest.prototype.open);
    (function (send) {
        XMLHttpRequest.prototype.send = function (data) {
            if (this.requestUrl && this.requestUrl.startsWith(apiUrl)) {
                this.withCredentials = true;
            }
            send.call(this, data);
        };
    })(XMLHttpRequest.prototype.send);
}
